<template>
	<div>
		<v-autocomplete
			class="pl-sm-4 siteDropdown"
			v-bind:value="value"
			v-on:input="handleInput"
			:items="types"
			:color="ada.blue"
			label="Sitetype"
			item-text="Name"
			item-value="Name"
			:loading="loadingSitetype"
			:readonly="selectedSite === null && typeof siteDetails === 'undefined'"
			flat
			chips
			return-object
			hide-details
			backgroundColor="#ffffff"
		>
			<template v-slot:selection="{ attr, on, item, selected }">
				<v-chip
					v-bind="attr"
					:input-value="selected"
					:color="ada.darkGrey"
					class="white--text"
					v-on="on"
					label
				>
                    <span v-text="item.Name"
													style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"></span>
				</v-chip>
			</template>
			<template v-slot:item="data">
				<v-list-item-content>
					<v-list-item-title><span>{{ data.item.Name }}</span></v-list-item-title>
					<v-list-item-subtitle><span>{{ data.item.group }}</span></v-list-item-subtitle>
				</v-list-item-content>
				<v-list-item-icon @click.stop="deleteSitetype(data.item)" v-if="!readOnly && !hideButtons">
					<v-tooltip right>
						<template v-slot:activator="{ on }">
							<v-icon v-on="on" color="red">
								mdi-delete
							</v-icon>
						</template>
						<span>Sitetype löschen</span>
					</v-tooltip>
				</v-list-item-icon>
			</template>
			<template v-if="!hideButtons" v-slot:append-outer="">
				<div style="position: relative;bottom: -7px;display:flex;">
					<!-- COPY SITETYPE-->
					<TooltipIcon v-if="!readOnly && value"
											 :custom-style="{marginRight: '10px'}"
											 :color="ada.darkGrey"
											 :fab="true"
											 :xsmall="true" @click="showCopySitetypeDialog = true"
											 tooltip="Sitetype kopieren">mdi-content-copy
					</TooltipIcon>
					<!-- ADD SITETYPE-->
					<TooltipIcon v-if="!readOnly" :disabled="selectedSite === null" :color="ada.blue"
											 :fab="true"
											 :xsmall="true" @click="showAddSitetypeDialog = true"
											 tooltip="Sitetype hinzufügen">mdi-plus
					</TooltipIcon>
				</div>
			</template>
		</v-autocomplete>

		<AddSitetypeDialog v-model="showAddSitetypeDialog"></AddSitetypeDialog>
		<CopySitetypeDialog v-model="showCopySitetypeDialog"></CopySitetypeDialog>
		<DeleteSitetypeDialog v-model="showDeleteSitetypeDialog" :data="toBeDeletedSitetype" ok-text="Fortfahren"
		></DeleteSitetypeDialog>
	</div>
</template>

<script>
import TooltipIcon from "../../components/TooltipIcon";
import ada from "../../scss/ada_colors.scss";
import DeleteSitetypeDialog from "../Display/Dialogs/DeleteSitetypeDialog";
import CopySitetypeDialog from "../Display/Dialogs/CopySitetypeDialog";
import AddSitetypeDialog from "../Display/Dialogs/AddSitetypeDialog";

export default {
	name: "SitetypeSelect",
	components: {AddSitetypeDialog, CopySitetypeDialog, DeleteSitetypeDialog, TooltipIcon},
	props: {
		value: {},
		beforeChangeEvent: {
			type: Boolean,
			default: false
		},
		hideButtons: {
			type: Boolean,
			default: false,
		},
		store: {
			type: String,
			default: 'display'
		},
		loading: {
			type: Boolean
		},
		siteDetails: {
			type: Object
		}
	},
	data: () => {
		return {
			showDeleteSitetypeDialog: false,
			toBeDeletedSitetype: null,
			showCopySitetypeDialog: false,
			showAddSitetypeDialog: false,
			ada
		}
	},
	computed: {
		vuexState() {
			return this.$store.state[this.store];
		},
		types() {
			let siteDetails = typeof this.siteDetails !== "undefined" ? this.siteDetails : this.vuexState.siteDetails;
			return siteDetails && siteDetails.Types ? siteDetails.Types : [];
		},
		loadingSitetype() {
			return typeof this.loading !== "undefined" ? this.loading : this.loadingSitetype_store;
		},
		loadingSitetype_store() {
			return this.vuexState.loadingSitetype;
		},
		selectedSite() {
			return this.vuexState.selectedSite;
		},
		readOnly() {
			return this.$store.state.readOnly === 1;
		},
	},
	methods: {
		init() {
			this.$emit('input', this.types.find(x => x.Type === 'desktop') || this.types[0]);
		},
		handleInput($event) {
			this.beforeChangeEvent ? this.$emit('beforeChange', $event) : this.$emit('input', $event);
		},
		deleteSitetype(item) {
			this.showDeleteSitetypeDialog = true;
			this.toBeDeletedSitetype = item;
		},
	},
	watch: {
		types(n, o) {
			if ((o === null && n !== null) || n.map(x => x.SitetypeId).sort().toString() !== o.map(x => x.SitetypeId).sort().toString()) {
				this.init();
			}
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .v-text-field {
	.v-label {
		top: 14px;

	}

	.v-label--active {
		transform: translateY(-26px) scale(0.75);
	}
}

::v-deep .siteDropdown {
	padding-top: 11px;

	.v-input__slot {

		padding: 5px 0 5px 10px;
		border-top-right-radius: 4px;
	}

	.v-label {
		left: -10px !important;
		top: 6px;
		overflow: initial;
		background: #fff;
		padding: 8px 20px;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
	}

	.v-input__append-inner .v-input__icon {
		position: relative;
		bottom: -5px;
	}
}
</style>